// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"styles__buttonWrapper___1y66W","icon":"styles__icon___FFwMt"};